module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "fronthead2"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/004_intro#intro",
      "id": "intro_"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/005_barak#brief",
      "id": "brief_"
    }
  }, [_vm._v("Barack Obama in Brief")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "tochead"
  }, [_c('a', {
    attrs: {
      "href": "#/html/006_quotes#quotes",
      "id": "quotes_"
    }
  }, [_vm._v("The Quotes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/007_chap1#c1",
      "id": "c1_"
    }
  }, [_vm._v("ON ABORTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/008_chap2#c2",
      "id": "c2_"
    }
  }, [_vm._v("ON ABRAHAM LINCOLN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/009_chap3#c3",
      "id": "c3_"
    }
  }, [_vm._v("ON AFGHANISTAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/010_chap4#c4",
      "id": "c4_"
    }
  }, [_vm._v("ON AFRICA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/011_chap5#c5",
      "id": "c5_"
    }
  }, [_vm._v("ON THE AFRICAN-AMERICAN COMMUNITY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/012_chap6#c6",
      "id": "c6_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON AIDS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/013_chap7#c7",
      "id": "c7_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE AMERICAN CHARACTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/014_chap8#c8",
      "id": "c8_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE AMERICAN DREAM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/015_chap9#c9",
      "id": "c9_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON BEING A CHRISTIAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/016_chap10#c10",
      "id": "c10_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON BIPARTISANSHIP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/017_chap11#c11",
      "id": "c11_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON BLUE STATES AND RED STATES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/018_chap12#c12",
      "id": "c12_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON BOOKS THAT HAVE INSPIRED HIM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/019_chap13#c13",
      "id": "c13_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON CAMPAIGN FINANCE REFORM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/020_chap14#c14",
      "id": "c14_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS CHILDHOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/021_chap15#c15",
      "id": "c15_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS CHILDREN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/022_chap16#c16",
      "id": "c16_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON CHINA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/023_chap17#c17",
      "id": "c17_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS CIGARETTE HABIT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/024_chap18#c18",
      "id": "c18_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE CLINTONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/025_chap19#c19",
      "id": "c19_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON CONGRESS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/026_chap20#c20",
      "id": "c20_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS CRITICS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/027_chap21#c21",
      "id": "c21_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE CURRENT STATE OF POLITICS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/028_chap22#c22",
      "id": "c22_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON DARFUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/029_chap23#c23",
      "id": "c23_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS DECISION TO RUN FOR PRESIDENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/030_chap24#c24",
      "id": "c24_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON DEMOCRACY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/031_chap25#c25",
      "id": "c25_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE DEMOCRATIC PARTY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/032_chap26#c26",
      "id": "c26_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON DIVERSITY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/033_chap27#c27",
      "id": "c27_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON EDUCATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/034_chap28#c28",
      "id": "c28_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON ENERGY POLICY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/035_chap29#c29",
      "id": "c29_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE ECONOMY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/036_chap30#c30",
      "id": "c30_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON EQUAL RIGHTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/037_chap31#c31",
      "id": "c31_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON EXERCISE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/038_chap32#c32",
      "id": "c32_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON FOREIGN POLICY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/039_chap33#c33",
      "id": "c33_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON FREE TRADE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/040_chap34#c34",
      "id": "c34_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE FUTURE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/041_chap35#c35",
      "id": "c35_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON GAY MARRIAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/042_chap36#c36",
      "id": "c36_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON GAYS IN THE MILITARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/043_chap37#c37",
      "id": "c37_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON GENERATIONAL CONFLICT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/044_chap38#c38",
      "id": "c38_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON GLOBAL WARMING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/045_chap39#c39",
      "id": "c39_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON GLOBALIZATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/046_chap40#c40",
      "id": "c40_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON GUN CONTROL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/047_chap41#c41",
      "id": "c41_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HEALTH CARE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/048_chap42#c42",
      "id": "c42_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HILLARY CLINTON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/049_chap43#c43",
      "id": "c43_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HOMELAND SECURITY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/050_chap44#c44",
      "id": "c44_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HOW HE MAKES DECISIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/051_chap45#c45",
      "id": "c45_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON IMMIGRATION POLICY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/052_chap46#c46",
      "id": "c46_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON IMPEACHING BUSH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/053_chap47#c47",
      "id": "c47_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE INTERNET")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/054_chap48#c48",
      "id": "c48_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON IRAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/055_chap49#c49",
      "id": "c49_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON IRAQ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/056_chap50#c50",
      "id": "c50_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON ISLAM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/057_chap51#c51",
      "id": "c51_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON ISOLATIONISM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/058_chap52#c52",
      "id": "c52_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON ISRAEL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/059_chap53#c53",
      "id": "c53_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE ISSUES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/060_chap54#c54",
      "id": "c54_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON JOBS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/061_chap55#c55",
      "id": "c55_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON JOHN McCAIN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/062_chap56#c56",
      "id": "c56_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS KEYNOTE SPEECH AT THE 2004 DEMOCRATIC CONVENTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/063_chap57#c57",
      "id": "c57_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS LACK OF EXPERIENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/064_chap58#c58",
      "id": "c58_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON LIBERALS VS. CONSERVATIVES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/065_chap59#c59",
      "id": "c59_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS MARRIAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/066_chap60#c60",
      "id": "c60_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE MEDIA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/067_chap61#c61",
      "id": "c61_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE MIDDLE EAST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/068_chap62#c62",
      "id": "c62_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE MILITARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/069_chap63#c63",
      "id": "c63_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE MINIMUM WAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/070_chap64#c64",
      "id": "c64_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON MIXING POLITICS AND RELIGION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/071_chap65#c65",
      "id": "c65_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE MORTGAGE CRISIS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/072_chap66#c66",
      "id": "c66_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS MULTIRACIAL HERITAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/073_chap67#c67",
      "id": "c67_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS NAME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/074_chap68#c68",
      "id": "c68_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON NATIONAL SECURITY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/075_chap69#c69",
      "id": "c69_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON NATIVE AMERICANS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/076_chap70#c70",
      "id": "c70_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON NORTH KOREA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/077_chap71#c71",
      "id": "c71_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON NUCLEAR WEAPONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/078_chap72#c72",
      "id": "c72_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS PERSONAL INTEGRITY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/079_chap73#c73",
      "id": "c73_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS PERSONAL STRENGTHS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/080_chap74#c74",
      "id": "c74_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS POLITICAL AGENDA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/081_chap75#c75",
      "id": "c75_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON POLITICAL CAMPAIGNING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/082_chap76#c76",
      "id": "c76_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS POLITICAL CAREER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/083_chap77#c77",
      "id": "c77_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON POLITICAL PARTIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/084_chap78#c78",
      "id": "c78_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON A POLITICIAN’S PAST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/085_chap79#c79",
      "id": "c79_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON POLITICS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/086_chap80#c80",
      "id": "c80_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON HIS POPULARITY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/087_chap81#c81",
      "id": "c81_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON PORK-BARREL SPENDING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/088_chap82#c82",
      "id": "c82_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE PRESIDENCY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/089_chap83#c83",
      "id": "c83_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON PRESIDENT GEORGE W. BUSH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/090_chap84#c84",
      "id": "c84_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE PRESIDENT HE’D BE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/091_chap85#c85",
      "id": "c85_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE PRIMARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/092_chap86#c86",
      "id": "c86_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON PRIVACY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/093_chap87#c87",
      "id": "c87_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON RACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/094_chap88#c88",
      "id": "c88_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE RECESSION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/095_chap89#c89",
      "id": "c89_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON RELIGION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/096_chap90#c90",
      "id": "c90_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON REPUBLICANS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/097_chap91#c91",
      "id": "c91_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE REVEREND JEREMIAH WRIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/098_chap92#c92",
      "id": "c92_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE ROLE OF GOVERNMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/099_chap93#c93",
      "id": "c93_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON RURAL ISSUES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/100_chap94#c94",
      "id": "c94_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON SADDAM HUSSEIN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/101_chap95#c95",
      "id": "c95_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON SECULAR SOCIETY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/102_chap96#c96",
      "id": "c96_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE SENATE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/103_chap97#c97",
      "id": "c97_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE SEPARATION OF CHURCH AND STATE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/104_chap98#c98",
      "id": "c98_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON SMALL BUSINESS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/105_chap99#c99",
      "id": "c99_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON SPREADING DEMOCRACY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/106_chap100#c100",
      "id": "c100_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON STEM CELL RESEARCH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/107_chap101#c101",
      "id": "c101_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON TEACHING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/108_chap102#c102",
      "id": "c102_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON TERRORISM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/109_chap103#c103",
      "id": "c103_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON VETERANS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/110_chap104#c104",
      "id": "c104_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON VOTER ID CARDS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/111_chap105#c105",
      "id": "c105_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON WAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/112_chap106#c106",
      "id": "c106_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE WAR ON TERROR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/113_chap107#c107",
      "id": "c107_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON WASHINGTON, D.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/114_chap108#c108",
      "id": "c108_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON WRITING BOOKS")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/115_acknow#acknow",
      "id": "acknow_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/116_about#about",
      "id": "about_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/117_cr#cr",
      "id": "cr_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6164bca2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/003_toc.vue
// module id = 63
// module chunks = 0